import styled, { css } from 'styled-components/macro'

const gray = '#FFFFFF66'
const yellow = '#E5FF00'
// TODO: TAKE THIS DESIGN SYSTEM COLOR WHEN IT'S AVAILABLE
// const gray = ({ theme }) => theme.wsc.palette.neutral[700]
// const yellow = ({ theme }) => theme.wsc.palette.primary[300]

type CustomProps = {
  value: number
}

//the background of the volume slider is a gradient that goes from yellow to gray
const rangInputBackgroundCss = css<CustomProps>`
  background: ${(props) =>
    `linear-gradient(to right, ${yellow} 0%, ${yellow} ${props.value}%, ${gray} ${props.value}%, ${gray} 100%);`};
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);
`

export const StyledProgressBar = styled.input.attrs({ type: 'range' })<CustomProps>`
  -webkit-appearance: none;
  -moz-appearance: none;
  outline: 0;
  height: 4px;
  ${rangInputBackgroundCss}
  ::-webkit-slider-thumb {
    -webkit-appearance: none;
  }
  ::-moz-range-thumb {
    -moz-appearance: none;
  }
  &:hover {
    ::-webkit-slider-thumb {
      -webkit-appearance: none;
      width: 12px;
      height: 12px;
      background: ${yellow};
      border-radius: 50%;
    }

    ::-moz-range-thumb {
      width: 12px;
      height: 12px;
      -moz-appearance: none;
      background: ${yellow};
      border-radius: 50%;
    }
  }
`

export const StyledProgressBarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  width: 100%;
`
export const StyledTimeDisplay = styled.div`
  margin-left: 12px;
  font-size: 12px;
  color: #fff;
  white-space: nowrap;
`
